import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states = [{
    name: 'editEmail',
    url: '/editEmail/:guid',
    component: 'wtEditEmailState',
    resolve: {
        auth: Resolve.authResolve,
        connected: Resolve.connectedResolve,
        roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer])
    },
    data: {
        sortingOrder: -1,
        visible: false,
        icon: '',
        displayName: 'Edit Email',
        editRoles: [Roles.administrator, Roles.master, Roles.engineer],
        editButtonVisibility: () => true,
        editButtonDisabled: () => true
    }
}];

export default states;